<template>
  <!-- 题目类组件 -->
  <div class="ModuleTopic">
    <check-box v-if="questionType==2||questionType==3" :data="obj" :disabledBol="disabledBol"></check-box>
    <bl-input v-else-if="questionType==6" :data="obj" :disabledBol="disabledBol"></bl-input>
    <short-answer v-else-if="questionType==8||questionType==10" :data="obj" :disabledBol="disabledBol"></short-answer>
    <Rate v-else-if="questionType==7" :data="obj" :disabledBol="disabledBol"></Rate>
    <Submit v-else-if="questionType==9" :data="obj" :disabledBol="disabledBol" :showAi="showAi" @showAifalse="showAifalse"></Submit>
    <select-box v-else-if="(questionType==1)&&(obj && obj.rule?obj.rule.isSelect==1:false)" :data="obj" :disabledBol="disabledBol"></select-box>
    <select-date v-else-if="questionType==11" :data="obj" :disabledBol="disabledBol"></select-date>
    <inventory-box v-else-if="questionType==12" :data="obj" :disabledBol="disabledBol"></inventory-box>
    <!-- 写作 -->
    <writing-box v-else-if="questionType==13" :data="obj" :disabledBol="disabledBol"></writing-box>
  </div>
</template>

<script>

import CheckBox from './public/check-box'
import blInput from './public/input'
import ShortAnswer from './public/short-answer'
import Rate from './public/rate'
import Submit from './public/submit'
import SelectBox from './public/select-box'
import SelectDate from './public/select-date'
import InventoryBox from './public/inventory-box'
import WritingBox from './public/writing-box'

export default {
  props: {
    data: Object,
    topicList: Object,
    disabledBol: Boolean
  },
  name: 'ModuleTopic',
  data () {
    return {
      questionType: null,      // 题目类型
      obj: null,                // 题目内容
      showAi: false              // 展示ai
    }
  },
  methods: {
    getAiSort () {
      let data = {
        taskRelationId: this.$route.query.taskRelationId || '',
        taskGroupType: this.$route.query.taskGroupType || ''
      }
      this.$api.post('TEST_API_EXAM_PAPER_AI', data, (res) => {
        if (+res.data === 1) {
          this.showAi = true
        }
      })
    },
    // 获取题目
    getTopic (id) {
      this.obj = this.topicList[this.data.questionId]
      if (this.obj && +this.obj.isOpenAi === 1) {
        // 开启了ai的题目
        this.getAiSort()
      }
      this.questionType = this.obj && this.obj.questionType ? this.obj.questionType : null
      this.$emit('getTopic', this.obj)
    },
    showAifalse () {
      this.showAi = false
      this.$forceUpdate()
    }
  },
  watch: {
    'topicList' () {
      this.getTopic()
    }
  },
  created () {
    // this.getTopic()
  },
  components: {
    CheckBox,
    blInput,
    ShortAnswer,
    Rate,
    Submit,
    SelectBox,
    SelectDate,
    InventoryBox,
    WritingBox
  }
}
</script>

<style lang="scss">
.ModuleTopic{
  .el-input__icon{
    font-style: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/topic/main.vue